module.exports = __webpack_public_path__ + "static/media/MHV-logo 2.21958b8b.svg";